<div *ngIf="!hideIfMobile" class="content-wrapper {{ data.transition }}">
    <div
        *ngIf="!animateClass && subscribeToInViewport && animationCount > 0"
        (finderInViewport)="animateToggle()"
        [addedOffset]="viewportOffset">
    <!--
        this will subscribe to the inViewport directive,
        we turn off/on to resubscribe if the animation
        needs to be repeated more than once.
    -->
    </div>
    <div
        #content
        class="content"
        [ngClass]="{ animate: animateClass }"
        [ngStyle]="contentStyles"
    >
        <ng-content></ng-content>
    </div>
</div>
<div
    class="animation-wrapper {{ data.transition }}"
    *ngIf="!hideIfMobile"
    [ngClass]="{ animate: animateClass, 'page-level': data.pageLevel }"
    [ngStyle]="animateClass ? wrapperStyles : ''"
>
    <div [ngStyle]="spriteStyles" class="animation-sprite"></div>
</div>
